import { Skeleton } from '@chakra-ui/react';

export const ListingFiltersSkeletonDesktopReservationSwitch = () => <Skeleton height="66px" />;
